/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Emptymysessions2Inputs */

const zh_learn_emptymysessions2 = /** @type {(inputs: Learn_Emptymysessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你还没有创建任何学习资源。`)
};

const en_learn_emptymysessions2 = /** @type {(inputs: Learn_Emptymysessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You haven't created any learning resources yet.`)
};

const es_learn_emptymysessions2 = /** @type {(inputs: Learn_Emptymysessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no has creado ningún recurso de aprendizaje.`)
};

/**
* | output |
* | --- |
* | "You haven't created any learning resources yet." |
*
* @param {Learn_Emptymysessions2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_emptymysessions2 = /** @type {((inputs?: Learn_Emptymysessions2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Emptymysessions2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_emptymysessions2(inputs)
	if (locale === "en") return en_learn_emptymysessions2(inputs)
	return es_learn_emptymysessions2(inputs)
});
export { learn_emptymysessions2 as "learn_emptyMySessions" }